var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoiseMode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8088 11.6841L10.8088 17.9841M10.8088 62.0841L10.8088 55.7841M23.4088 11.6841V17.9841V24.2841M36.0088 11.6841V17.9841V24.2841M36.0088 62.0841V55.7841M48.6088 11.6841V17.9841V24.2841V30.5841M48.6088 62.0841V55.7841V49.4841V43.1841M23.4088 36.8841V43.1841V49.4841V62.0841M36.0088 34.0841V45.9841M61.2088 28.4841V11.6841M61.2088 39.6841V45.9841M10.8088 43.1841L10.8088 36.8841L10.8088 30.5841M61.2088 55.7841V62.0841",
    stroke: "#2D3B67",
    strokeWidth: 2.61544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2088 39.6836V45.9836",
    stroke: "#2D3B67",
    strokeWidth: 3.66162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6089 11.6841V17.9841V24.2841V30.5841",
    stroke: "#2D3B67",
    strokeWidth: 3.66162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8088 43.1835L10.8088 36.8835L10.8088 30.5835",
    stroke: "#2D3B67",
    strokeWidth: 3.66162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0088 62.0842V55.7842",
    stroke: "#2D3B67",
    strokeWidth: 3.66162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4087 11.6841V17.9841V24.2841",
    stroke: "#2D3B67",
    strokeWidth: 3.66162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoiseMode);
export default __webpack_public_path__ + "static/media/noise_mode.0577775d76aba8b6aaef1d02613219bc.svg";
export { ForwardRef as ReactComponent };